/*
  Dinowax marquee — keeps the scrolling band gap-free.

  The CSS on its own renders the phrase list twice and shifts the track by -50%,
  i.e. exactly one copy. That only looks seamless while a single copy is at
  least as wide as the viewport. Measured on the homepage a copy is ~1114px, so
  on a 1920px screen an 806px hole sweeps through on every pass — the phrases
  vanish for a stretch, then reappear.

  Fix: clone the list until it comfortably overflows the viewport, then shift by
  exactly one copy's width instead of a percentage of the whole track. Because
  the shift is always one copy, the scroll speed stays whatever the merchant set
  regardless of how many clones it took.

  The two copies in the markup are the no-JS fallback, so the band still scrolls
  (just with the gap) if this never runs.
*/
(function () {
  'use strict';

  var CLONE_ATTR = 'data-dw-marquee-clone';

  function measure(el) {
    return el.getBoundingClientRect().width;
  }

  function fill(root) {
    var track = root.querySelector('.dw-marquee__track');
    if (!track) return;

    // Start from a clean slate — this runs again on resize and on section
    // reload in the theme editor, where the phrase list may have changed.
    var clones = track.querySelectorAll('[' + CLONE_ATTR + ']');
    for (var i = 0; i < clones.length; i++) clones[i].remove();

    var groups = track.querySelectorAll('.dw-marquee__group');
    if (!groups.length) return;

    var master = groups[0];
    var groupWidth = measure(master);

    // Web fonts can land after this runs; a zero measurement means the band is
    // not laid out yet, so leave the CSS fallback in place and try again later.
    if (groupWidth < 1) return;

    // Two copies is the minimum for a seamless loop. Beyond that we need enough
    // width that the track still covers the viewport once it has shifted by a
    // full copy — hence viewport + one copy, rounded up.
    var needed = Math.max(2, Math.ceil((root.clientWidth + groupWidth) / groupWidth) + 1);

    for (var n = groups.length; n < needed; n++) {
      var clone = master.cloneNode(true);
      clone.setAttribute(CLONE_ATTR, '');
      clone.setAttribute('aria-hidden', 'true');
      // Cloned blocks must not be clickable targets in the theme editor.
      clone.removeAttribute('data-shopify-editor-block');
      track.appendChild(clone);
    }

    // Shift by one copy in pixels rather than a share of the track, so the
    // distance is independent of the clone count.
    track.style.setProperty('--dw-marquee-shift', groupWidth + 'px');

    // The keyframes are already running against the old value; restart so the
    // new distance takes effect from the top of the loop.
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.animation = '';
  }

  function fillAll(scope) {
    var roots = (scope || document).querySelectorAll('.dw-marquee');
    for (var i = 0; i < roots.length; i++) fill(roots[i]);
  }

  function init() {
    fillAll();

    // Re-measure once fonts have settled — phrase widths move with the webfont.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fillAll(); });
    }

    var pending;
    window.addEventListener('resize', function () {
      clearTimeout(pending);
      pending = setTimeout(function () { fillAll(); }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: the section is re-rendered on every settings change.
  document.addEventListener('shopify:section:load', function (event) {
    fillAll(event.target);
  });
})();
